export enum PackageType {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  PRO = "PRO",
  BUSINESS = "BUSINESS",
  ENTERPRISE = "ENTERPRISE",
  ONE_TIME_T1 = "ONE_TIME_T1",
  ONE_TIME_T2 = "ONE_TIME_T2",
  ONE_TIME_T3 = "ONE_TIME_T3",
}

export enum PricingPlan {
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export interface PackagePrice {
  created_at: string;
  currency: "$";
  deleted_at: null;
  id: string;
  package_id: string;
  plan: PricingPlan;
  price: number;
  stripe_price_id: string;
  updated_at: string;
}

export enum AddOns {
  TICKET = "Ticket Support",
  MAILBOX = "Mailbox",
  WHITE_LABEL = "White Label",
  HELP_DESK = "Help Desk",
}

export enum Channels {
  WEBSITE = "WEBSITE",
  MOBILE = "MOBILE",
}

export interface Package {
  id: string;
  name: string;
  currency: string;
  price: number;
  chatbot_number?: number;
  message_number?: number;
  type: PackageType;
  chatbot_data_limit: number;
  max_monthly_messages?: number;
  max_monthly_credit?: number;
  max_monthly_conversation?: number;
  max_member?: number;
  max_bot?: number;
  max_bot_data?: number;
  prices: PackagePrice[];
  order: number;
  features: {
    ai_agent: boolean;
    ai_auto_reply: boolean;
    live_chat: boolean;
    workflow: boolean;
    number_of_chatbot: number;
    bot_for_multiples_brand: boolean;
    customized_model: boolean;
    ai_suggest: boolean;
    add_ons: AddOns[];
    channels: Channels[];
    integration: string;
    api_access: boolean;
  };
}
